import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import commonPreviewStyles from './commonStyles';
import { formatDateShort, getCurrentYear } from 'utils/time.util';

// Create styles
const styles = StyleSheet.create({
  ...commonPreviewStyles,
  formTitle: {
    ...commonPreviewStyles.formTitle,
    paddingTop: 40,
  },
});

function CompressionPdfPreview(props) {
  const { records, device, addProps } = props;
  const { chartImages } = addProps;

  if (!chartImages) {
    return <Document />;
  }

  return (
    <Document>
      {records &&
        records.map((record) => (
          <Page key={record.entries[0]._id} style={styles.body} orientation="portrait">
            <View fixed style={styles.footer}>
              <Text
                style={styles.header}
                render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`}
                fixed
              />
              <Text fixed style={styles.header}>
                Provided By Radiology QC Solutions
              </Text>
            </View>
            <Text style={styles.formTitle}>Compression Thicknes Indicator</Text>

            <View key={record.entries[0]._id} style={styles.scannerInfoView}>
              <Text style={styles.scannerInfo}>Facility : {device.facilityName}</Text>
              <Text style={styles.scannerInfo}>Scanner: {`${device.name} (${device.apNumber})`}</Text>
            </View>

            <View style={styles.entryTable}>
              <View style={styles.subContainerRight}>
                <Text style={styles.entryHeader}>Date</Text>
                <Text style={styles.entryHeader}>Initials</Text>
                <Text style={styles.entryHeader}>Thickness</Text>
              </View>
              {record.entries.map((entry) => {
                if (!entry.compThickPerformed) {
                  return null;
                }
                return (
                  <View key={entry._id} style={styles.subContainerRight}>
                    <Text style={styles.entry}>{formatDateShort(entry.date)}</Text>
                    <Text style={styles.entry}>{entry.initials}</Text>
                    <Text style={styles.entry}>{entry.compThickness}</Text>
                  </View>
                );
              })}
            </View>

            <Text style={styles.chartTitle}>Summary Charts (See Below).</Text>
            <View style={styles.chartSections}>
              {chartImages.compthickDiff && <Image style={styles.charts} src={chartImages.compthickDiff} />}
            </View>

            <View style={styles.remarksHeaderView}>
              <Text style={styles.remarksTableShort}>Date</Text>
              <Text style={styles.remarksTableShort}>Initials</Text>
              <Text style={styles.remarks}>Actions</Text>
            </View>

            {record.entries.map(
              (entry) =>
                entry.compRemarks.length > 0 && (
                  <View key={entry._id} style={styles.remarksView}>
                    <Text style={styles.remarksTableShort}>{formatDateShort(entry.date)}</Text>
                    <Text style={styles.remarksTableShort}>{entry.initials}</Text>
                    <Text style={styles.remarks}>{entry.compRemarks}</Text>
                  </View>
                ),
            )}

            <View style={{ marginLeft: 32, marginRight: 32, textAlign: 'center' }}>
              <Text style={styles.copyRight}>© {getCurrentYear()} Radiology QC Solutions LLC</Text>
            </View>
          </Page>
        ))}
    </Document>
  );
}

CompressionPdfPreview.propTypes = {
  records: PropTypes.arrayOf(PropTypes.any),
  device: PropTypes.objectOf(PropTypes.any),
  addProps: PropTypes.objectOf(PropTypes.any),
};

CompressionPdfPreview.defaultProps = {
  records: [],
  device: null,
  addProps: {},
};

export default CompressionPdfPreview;
